module.exports = __webpack_public_path__ + "static/media/research-table-2.d0bf6ed7.png";